// client/src/pages/news/news.js
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';

import ogImg from '../../assets/img/og.jpg';

import Image from '../../components/shared/backgroundImage';
import Footer from '../../components/shared/Footer';
import NavBar from '../../components/shared/NavBar';
import Description from '../../components/shared/imageDescription';
import Explore from '../../components/shared/explore.js';
import AllNews from '../../components/news/allNews.js';

class NewsPage extends Component {
  constructor(props) {
    super(props);
    this.onTransitionEnd.bind(this);
    this.state = { transitionEnded: false };
  }

  onTransitionEnd = () => {
    this.setState({ transitionEnded: true });
  };

  render() {
    const heroClasses = classnames('hero', { animate: this.state.transitionEnded });

    const q = this.props.newsPageQuery || null;

    // Accept either the Apollo wrapper shape (q.data) OR the unwrapped shape (q)
    const data = q?.data && typeof q.data === 'object' ? q.data : q;

    // If still no data, show a gentle fallback (don't redirect to /)
    if (!data) {
      return (
        <div key="home" className={heroClasses}>
          <Helmet>
            <meta property="og:image" content={ogImg} />
          </Helmet>
          <header id="site-header" className="container" role="banner">
            <h1 style={{ padding: 24 }}>Cubs News</h1>
          </header>
          <main className="container" style={{ padding: 24 }}>
            <div>News data is currently unavailable. Please try again later.</div>
          </main>
        </div>
      );
    }

    // Defensive: ensure main nav / globalSites exist before rendering chrome
    const site0 = data.globalSites && data.globalSites[0] ? data.globalSites[0] : null;
    const mainNav = site0?.mainNavigation || null;
    const logoUrl = site0?.cubsLogo?.url || null;
    const heroData = data.newsPages?.[0] || null;

    return (
      <div key="home" className={heroClasses}>
        <Helmet>
          <meta property="og:image" content={ogImg} />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
        </Helmet>

        <header id="site-header" className="container" role="banner">
          <a id="site-title" className="h1" href="/">
            {logoUrl ? <img src={logoUrl} alt="site-header" /> : <span>Cubs News</span>}
          </a>

          {heroData ? <Image introBackgrounds={heroData} /> : null}

          {mainNav ? <NavBar NavBar={mainNav} /> : null}

          <div className="header-content">
            <div className="row2 padding-bottom">
              <Description description={data.newsPages || []} />
            </div>
          </div>
        </header>

        <main className="container">
          {/* Pass the actual data object down — spread it so child finders see top-level keys */}
          <AllNews {...data} />
          {data.exploreComponents?.[0] ? <Explore explore={data.exploreComponents[0]} /> : null}
        </main>

        {mainNav ? <Footer footer={mainNav} /> : null}
      </div>
    );
  }
}

export default withRouter(NewsPage);